import { render, staticRenderFns } from "./YouthProtection.vue?vue&type=template&id=7be1753c&scoped=true&"
import script from "./YouthProtection.vue?vue&type=script&lang=ts&"
export * from "./YouthProtection.vue?vue&type=script&lang=ts&"
import style0 from "./YouthProtection.vue?vue&type=style&index=0&id=7be1753c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be1753c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
